export const OPPORTUNITY_PIPELINE_TAB = "opportunity-pipeline"
export const SALES_SEARCH_LIMIT = 20
export const SUGGESTION_DEBOUNCE_MS = 300
